module.exports = __webpack_public_path__ + "img/drag.dea9378f.svg";